import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Title } from '@/components/Typography';

export const Header: React.FC = () => {
	return (
		<Row justify="center" style={{ marginTop: '1rem' }}>
			<Col>
				<Title level={2}>{I18n.get('Ergonomic evaluation') + ' JDS-D92'}</Title>
			</Col>
		</Row>
	);
};
